import { number, object, NumberSchema } from 'yup';
import { YupValidation } from '@/modules/common/helpers/yup-validation';

const schema = object().shape({
  totalInvested: number().required('Informe o valor em aplicações financeiras'),
  realEstate: number(),
  privatePension: number(),
  movableProperty: number().when('monthlyIncome', {
    is: 0,
    then: (schema: NumberSchema) =>
      schema.min(101, 'Informe um valor maior que R$ 100,00 para bens móveis.'),
    otherwise: (schema: NumberSchema) => schema
  }),
  monthlyIncome: number()
});

export default new YupValidation(schema);
